import {combineReducers } from 'redux';
import inicializacion_form from './inicializacion_form';
import ui from './ui';
import ventasReducer from './ventasReducer';
import clientesReducer from './clientesReducer';
import sesionReducer from './sesionReducer';
import bancosReducer from './bancosReducer';
import contabilidadReducer from './contabilidadReducer';
import inventarioReducer from './inventarioReducer';
import cajaReducer from './cajaReducer';
import generalesReducer from './generalesReducer';
import vendedoresReducer from './vendedoresReducer';
import { reducer as formReducer } from 'redux-form';


const rootReducer = combineReducers({inicializacion_form, ui, form: formReducer, ventas: ventasReducer, 
    clientes: clientesReducer, sesion: sesionReducer, bancos: bancosReducer, contabilidad: contabilidadReducer,
    inventario: inventarioReducer, caja: cajaReducer, generales: generalesReducer, vendedores :vendedoresReducer,
});

export default rootReducer;